import styles from './loading.module.scss';
const NAV_TABS = 4;
const AMENITY_CHIPS = 6;
const CAROUSEL_CARDS = 4;
export default function Loading() {
  const shimmer = styles.shimmer;
  return <div className={styles.page} role="status" aria-live="polite" aria-label="Loading workspace details" data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
            {/* Image gallery — mirrors ImageGallery 5-image grid */}
            <div className={styles.galleryWrap}>
                <div className={styles.galleryGrid} aria-hidden="true">
                    <div className={`${styles.galleryMain} ${shimmer}`} />
                    <div className={`${styles.galleryThumb} ${shimmer}`} />
                    <div className={`${styles.galleryThumb} ${shimmer}`} />
                    <div className={`${styles.galleryThumb} ${shimmer}`} />
                    <div className={`${styles.galleryThumb} ${shimmer}`} />
                </div>
                <div className={styles.galleryGridMobile} aria-hidden="true">
                    <div className={`${styles.galleryMobileMain} ${shimmer}`} />
                    <div className={`${styles.galleryMobileThumb} ${shimmer}`} />
                    <div className={`${styles.galleryMobileThumb} ${shimmer}`} />
                </div>
            </div>

            {/* Two-column body — mirrors ListingDetailsClient .container */}
            <div className={styles.container}>
                {/* Left column */}
                <div className={styles.mainCol}>
                    {/* Header: title + share/heart + location + stat chips */}
                    <div className={styles.headerSection} aria-hidden="true">
                        <div className={styles.titleRow}>
                            <div className={`${styles.titleBar} ${shimmer}`} />
                            <div className={styles.actions}>
                                <div className={`${styles.actionBtn} ${shimmer}`} />
                                <div className={`${styles.actionBtn} ${shimmer}`} />
                            </div>
                        </div>
                        <div className={`${styles.locationBar} ${shimmer}`} />
                        <div className={styles.statsRow}>
                            <div className={`${styles.statChip} ${shimmer}`} />
                            <div className={`${styles.statChip} ${shimmer}`} />
                        </div>
                    </div>

                    {/* Sticky nav pill — mirrors StickyNav */}
                    <div className={styles.navStrip} aria-hidden="true">
                        {Array.from({
            length: NAV_TABS
          }).map((_, i) => <span key={i} className={`${styles.navTab} ${shimmer}`} />)}
                    </div>

                    {/* About section */}
                    <div className={styles.infoSection} aria-hidden="true">
                        <div className={`${styles.infoHeading} ${shimmer}`} />
                        <div className={`${styles.infoLine} ${styles.infoLineFull} ${shimmer}`} />
                        <div className={`${styles.infoLine} ${styles.infoLineLong} ${shimmer}`} />
                        <div className={`${styles.infoLine} ${styles.infoLineMid} ${shimmer}`} />
                        <div className={`${styles.infoLine} ${styles.infoLineShort} ${shimmer}`} />
                    </div>

                    {/* Amenities grid — mirrors AmenitiesGrid */}
                    <div className={styles.infoSection} aria-hidden="true">
                        <div className={`${styles.infoHeading} ${shimmer}`} />
                        <div className={styles.amenitiesGrid}>
                            {Array.from({
              length: AMENITY_CHIPS
            }).map((_, i) => <div key={i} className={styles.amenityChip}>
                                    <span className={`${styles.amenityIcon} ${shimmer}`} />
                                    <span className={`${styles.amenityLabel} ${shimmer}`} />
                                </div>)}
                        </div>
                    </div>

                    {/* Reviews — heading + 2 review cards */}
                    <div className={styles.infoSection} aria-hidden="true">
                        <div className={`${styles.infoHeading} ${shimmer}`} />
                        <div className={styles.reviewRow}>
                            <span className={`${styles.reviewAvatar} ${shimmer}`} />
                            <div className={styles.reviewBody}>
                                <span className={`${styles.reviewName} ${shimmer}`} />
                                <span className={`${styles.infoLine} ${styles.infoLineFull} ${shimmer}`} />
                                <span className={`${styles.infoLine} ${styles.infoLineMid} ${shimmer}`} />
                            </div>
                        </div>
                        <div className={styles.reviewRow}>
                            <span className={`${styles.reviewAvatar} ${shimmer}`} />
                            <div className={styles.reviewBody}>
                                <span className={`${styles.reviewName} ${shimmer}`} />
                                <span className={`${styles.infoLine} ${styles.infoLineLong} ${shimmer}`} />
                                <span className={`${styles.infoLine} ${styles.infoLineShort} ${shimmer}`} />
                            </div>
                        </div>
                    </div>

                    {/* Location — heading + map */}
                    <div className={styles.infoSection} aria-hidden="true">
                        <div className={`${styles.infoHeading} ${shimmer}`} />
                        <div className={`${styles.mapBlock} ${shimmer}`} />
                    </div>
                </div>

                {/* Right column — sticky BookingSidebar */}
                <aside className={styles.sideCol} aria-hidden="true">
                    <div className={`${styles.sidebarHoursRow} ${shimmer}`} />
                    <div className={styles.sidebarCard}>
                        <div className={`${styles.sidebarSelect} ${shimmer}`} />
                        <div className={`${styles.sidebarPriceLabel} ${shimmer}`} />
                        <div className={`${styles.sidebarPriceValue} ${shimmer}`} />
                        <div className={`${styles.sidebarCta} ${shimmer}`} />
                    </div>
                    <div className={`${styles.sidebarSecondary} ${shimmer}`} />
                </aside>
            </div>

            {/* Similar workspaces carousel */}
            <div className={styles.carouselWrap} aria-hidden="true">
                <div className={`${styles.carouselTitle} ${shimmer}`} />
                <div className={styles.carouselRow}>
                    {Array.from({
          length: CAROUSEL_CARDS
        }).map((_, i) => <div key={i} className={styles.carouselCard}>
                            <div className={`${styles.carouselImage} ${shimmer}`} />
                            <span className={`${styles.carouselLine} ${styles.carouselLineLong} ${shimmer}`} />
                            <span className={`${styles.carouselLine} ${styles.carouselLineShort} ${shimmer}`} />
                        </div>)}
                </div>
            </div>
        </div>;
}